























import Vue from 'vue'

export default Vue.extend({
  name: 'Process',
  data() {
    return {
      processList: [
        { uid: `1`, path: `/asset/process/commit.png`, title: `Initial commit`, description: `Tell us about yourself and what matters to you` },
        { uid: `3`, path: `/asset/process/review.png`, title: `Review`, description: `A human being will look at your submission and be in touch` },
        { uid: `5`, path: `/asset/process/peer.png`, title: `Peer programming`, description: `We get together and discuss your ambition in person` },
        { uid: `7`, path: `/asset/process/merge.png`, title: `Merge`, description: `Join our talent network and become part of our community` },
        { uid: `9`, path: `/asset/process/deploy.png`, title: `Deploy`, description: `We actively find project work that matches not only your skill, but your ambition` }
      ]
    }
  },
  methods: {
    processItemClass(index: any) {
      return index % 2 === 0 ? 'flex-row-reverse md:flex-row' : 'flex flex-row-reverse'
    }
  }
})
